import { useState } from 'react'
import { apiUserLogin, apiUserRegister } from '../server/ServiceCall'

interface Props {
  onLogin: (token: string, userCode: number, userName: string) => void
}

type Mode = 'login' | 'register'

export default function LoginPage({ onLogin }: Props) {
  const [mode,     setMode]     = useState<Mode>('login')
  const [userId,   setUserId]   = useState('')
  const [userPass, setUserPass] = useState('')
  const [userName, setUserName] = useState('')
  const [loading,  setLoading]  = useState(false)
  const [error,    setError]    = useState('')
  const [success,  setSuccess]  = useState('')

  async function handleLogin(e: React.FormEvent) {
    e.preventDefault()
    if (!userId.trim() || !userPass.trim()) { setError('아이디와 비밀번호를 입력하세요.'); return }
    setLoading(true); setError(''); setSuccess('')
    try {
      const res = await apiUserLogin(userId.trim(), userPass.trim())
      if (res.resultCode === '00') {
        const parts = res.resultData.split('\x18')
        const token    = parts[0] ?? ''
        const uCode    = parseInt(parts[1] ?? '0', 10)
        const uName    = parts[2] ?? userId
        onLogin(token, uCode, uName)
      } else {
        setError(res.resultMessage || '로그인 실패')
      }
    } catch {
      setError('서버 연결에 실패했습니다.')
    } finally {
      setLoading(false)
    }
  }

  async function handleRegister(e: React.FormEvent) {
    e.preventDefault()
    if (!userId.trim() || !userPass.trim() || !userName.trim()) {
      setError('모든 항목을 입력하세요.'); return
    }
    setLoading(true); setError(''); setSuccess('')
    try {
      const res = await apiUserRegister(userId.trim(), userPass.trim(), userName.trim())
      if (res.resultCode === '00') {
        setSuccess('가입 완료! 로그인해주세요.')
        setMode('login'); setUserPass(''); setUserName('')
      } else {
        setError(res.resultMessage || '회원가입 실패')
      }
    } catch {
      setError('서버 연결에 실패했습니다.')
    } finally {
      setLoading(false)
    }
  }

  function switchMode(m: Mode) {
    setMode(m); setError(''); setSuccess('')
    setUserId(''); setUserPass(''); setUserName('')
  }

  return (
    <div className="login-screen">
      <div className="login-box">
        <div className="login-title">이세계무림</div>
        <div className="login-sub">혈교의 그림자가 강호를 덮는다</div>

        <div className="login-tabs">
          <button className={`login-tab${mode==='login'?' active':''}`} onClick={() => switchMode('login')}>입문</button>
          <button className={`login-tab${mode==='register'?' active':''}`} onClick={() => switchMode('register')}>입문 신청</button>
        </div>

        {error   && <div className="login-msg error">{error}</div>}
        {success && <div className="login-msg success">{success}</div>}

        {mode === 'login' && (
          <form onSubmit={handleLogin} className="login-form">
            <label className="login-label">아이디</label>
            <input className="login-input" type="text" placeholder="아이디" value={userId}
              onChange={e => setUserId(e.target.value)} autoFocus />
            <label className="login-label">비밀번호</label>
            <input className="login-input" type="password" placeholder="비밀번호" value={userPass}
              onChange={e => setUserPass(e.target.value)} />
            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? '처리 중...' : '강호 입문'}
            </button>
          </form>
        )}

        {mode === 'register' && (
          <form onSubmit={handleRegister} className="login-form">
            <label className="login-label">아이디</label>
            <input className="login-input" type="text" placeholder="영문/숫자 4~20자" value={userId}
              onChange={e => setUserId(e.target.value)} autoFocus />
            <label className="login-label">비밀번호</label>
            <input className="login-input" type="password" placeholder="비밀번호" value={userPass}
              onChange={e => setUserPass(e.target.value)} />
            <label className="login-label">무림 별호</label>
            <input className="login-input" type="text" placeholder="강호에서 불릴 이름" value={userName}
              onChange={e => setUserName(e.target.value)} />
            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? '처리 중...' : '입문 신청'}
            </button>
          </form>
        )}
      </div>
    </div>
  )
}
